export const MODULE_NAME = 'order';
export const STATUS_IN_PROGRESS = 'in-progress';
export const ORDER_NUMBER_COOKIE = 'order_number';
export const ORDER_TOKEN_COOKIE = 'order_token';
